export const sortObjectsByProperty = (
  array: SelectOption[],
  property: keyof SelectOption
): SelectOption[] => {
  return [...array].sort((a, b) =>
    (a[property] as string).localeCompare(b[property] as string)
  );
};
